import PageHeader from "@/components/PageHeader";
import Spinner from "@/components/Spinner";
import { ResourceNotFound } from "@/components/ResourceNotFound";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { AttachmentsDisplaySection } from "@/components/AttachmentsDisplaySection";
import { useContestAgreementId } from "../hooks/useContestAgreementId";
import { useContestAgreementDetail } from "../hooks/useContestAgreementDetail";
import { ContestAgreementMenu } from "./ContestAgreementMenu";
import { ContestAgreementDetails } from "./ContestAgreementDetails";

export const ContestAgreementDirectory = () => {
  const id = useContestAgreementId();
  const { t } = useTranslation();
  const {
    query,
    breadcrumbItems,
    attachmentGroups,
    sendLinkMutation,
    handleGoToContractor,
  } = useContestAgreementDetail(id);

  const handleResendConfirm = useCallback(() => {
    sendLinkMutation.mutate(id);
  }, [id, sendLinkMutation]);

  if (query.isLoading || query.isPending) {
    return (
      <>
        <PageHeader breadcrumbItems={breadcrumbItems} />
        <div className="flex w-full items-center justify-center py-12">
          <Spinner label={t("table.loading")} />
        </div>
      </>
    );
  }

  if (!query.data) {
    return (
      <>
        <PageHeader breadcrumbItems={breadcrumbItems} />
        <ResourceNotFound />
      </>
    );
  }

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <ContestAgreementMenu
        id={id}
        isResendPending={sendLinkMutation.isPending}
        canSendAgreement2={!!query.data?.can_send_agreement2}
        onResendLink={handleResendConfirm}
        onGoToContractor={handleGoToContractor}
      />
      <div className="space-y-6">
        <ContestAgreementDetails />
        {attachmentGroups.length > 0 && (
          <CollapsibleSection
            title={t("contestAgreements.detail.filesSection")}
          >
            <AttachmentsDisplaySection groups={attachmentGroups} />
          </CollapsibleSection>
        )}
      </div>
    </>
  );
};
